import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
  $('.see-more-btn').on('click', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const $member = $btn.closest('.member-info');
    const $desc = $member.find('.member-desc');

    // Toggle visibility
    $desc.toggleClass('d-none d-lg-block');

    // Toggle la rotation du bouton
    $btn.toggleClass('rotated');

    // Détection de la langue
    const lang = document.documentElement.lang;
    const isEnglish = lang.startsWith('en');

    // Toggle button label selon la langue
    if ($desc.hasClass('d-none')) {
      $btn.contents().first()[0].textContent = isEnglish ? 'See more' : 'Voir plus';
    } else {
      $btn.contents().first()[0].textContent = isEnglish ? 'See less' : 'Voir moins';
    }
  });
});
